import React from "react";
import { navigatAfterCloseSession } from "components/BosSessionFromUrl";
import SessionContainer from "../../components/SessionView/SessionContainer";
import SessionView from "components/SessionView/SessionView";

// Redux
import { connect } from "react-redux";

function UserAccountPage(props) {
  const { currentSession, currentDataSegmentId } = props;
  const showNoControls = currentDataSegmentId ? false : true;

  const handleSessionClosed = (session) => {
    navigatAfterCloseSession(props.history, currentSession);
  };

  return (
    <SessionContainer uri={"/Workspace/Config/ConfigData/Benutzerprofil"} isPersistant={false} sessionClosed={handleSessionClosed} {...props} >
      <SessionView noControls={showNoControls} {...props} />
    </SessionContainer>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    currentSession: state.sessions.openSessions.find(item => item.id === state.sessions.currentSessionId),
    currentDataSegmentId: state.dataSegments.currentDataSegmentId,
  };
}

export default
  connect(
    mapStateToProps
  )(UserAccountPage);
